module.exports = __webpack_public_path__ + "static/media/dashboard_icon.267f178a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dashboard_icon.svg
// module id = 169
// module chunks = 0